"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const googleAnalytics = require("react-ga");
const state_1 = require("@airstudio/state");
const foundations_1 = require("@airstudio/foundations");
class GoogleAnalytics extends state_1.Extensions.Abstract {
    constructor() {
        super();
        this.key = 'googleanalytics';
        state_1.Bus.onConfigReady(({ ga }) => {
            if (!ga) {
                // tslint:disable-next-line: no-console
                return console.warn('GoogleAnalytics extension is activated but backend config did not provide a `ga` value');
            }
            googleAnalytics.initialize(ga);
            this.dispatchSuccess({});
        });
        state_1.Bus.onUserReady(({ userId }) => {
            googleAnalytics.set({ userId });
        });
        foundations_1.History.browserHistory.listen((location) => {
            googleAnalytics.pageview(`${location.pathname}${location.search}${location.hash}`);
        });
        state_1.Bus.onAnalytics(({ eventName, value }) => {
            const [category, ...actions] = eventName.split('.');
            googleAnalytics.event({
                category, value, action: actions.join('.'),
            });
        });
    }
}
exports.GoogleAnalytics = GoogleAnalytics;
//# sourceMappingURL=index.js.map